import React from "react";
import ScrollBottomButton from "../../../components/ScrollButton/ScrollBottomButton";
import ScrollTopButton from "../../../components/ScrollButton/ScrollTopButton";
function Gallery2022(props) {
  const folder1 = [...Array(6)].map((e, i) => {
    let ext = "jpg";
    return (
      <img
        style={{ border: "1px solid black" }}
        className={"champions-images"}
        alt="2022"
        src={require(`../../../images/gallery/2022/1/img_${i + 1}.${ext}`)}
      />
    );
  });
  const folder2 = [...Array(4)].map((e, i) => {
    let ext = "jpg";
    return (
      <img
        style={{ border: "1px solid black" }}
        className={"champions-images"}
        alt="2022"
        src={require(`../../../images/gallery/2022/2/img_${i + 1}.${ext}`)}
      />
    );
  });
  const folder3 = [...Array(6)].map((e, i) => {
    let ext = "jpg";
    return (
      <img
        style={{ border: "1px solid black" }}
        className={"champions-images"}
        alt="2022"
        src={require(`../../../images/gallery/2022/3/img_${i + 1}.${ext}`)}
      />
    );
  });
  const folder4 = [...Array(5)].map((e, i) => {
    let ext = "jpg";
    return (
      <img
        style={{ border: "1px solid black" }}
        className={"champions-images"}
        alt="2022"
        src={require(`../../../images/gallery/2022/4/img_${i + 1}.${ext}`)}
      />
    );
  });
  const folder5 = [...Array(6)].map((e, i) => {
    let ext = "jpg";
    return (
      <img
        style={{ border: "1px solid black" }}
        className={"champions-images"}
        alt="2022"
        src={require(`../../../images/gallery/2022/5/img_${i + 1}.${ext}`)}
      />
    );
  });
  const folder6 = [...Array(2)].map((e, i) => {
    let ext = "jpg";
    return (
      <img
        style={{ border: "1px solid black" }}
        className={"champions-images"}
        alt="2022"
        src={require(`../../../images/gallery/2022/6/img_${i + 1}.${ext}`)}
      />
    );
  });
  const folder7 = [...Array(8)].map((e, i) => {
    let ext = "jpg";
    return (
      <img
        style={{ border: "1px solid black" }}
        className={"champions-images"}
        alt="2022"
        src={require(`../../../images/gallery/2022/7/img_${i + 1}.${ext}`)}
      />
    );
  });
  const folder8 = [...Array(4)].map((e, i) => {
    let ext = "jpg";
    return (
      <img
        style={{ border: "1px solid black" }}
        className={"champions-images"}
        alt="2022"
        src={require(`../../../images/gallery/2022/8/img_${i + 1}.${ext}`)}
      />
    );
  });
  const folder9 = [...Array(4)].map((e, i) => {
    let ext = "jpg";
    return (
      <img
        style={{ border: "1px solid black" }}
        className={"champions-images"}
        alt="2022"
        src={require(`../../../images/gallery/2022/9/img_${i + 1}.${ext}`)}
      />
    );
  });
  const folder10 = [...Array(5)].map((e, i) => {
    let ext = "jpg";
    return (
      <img
        style={{ border: "1px solid black" }}
        className={"champions-images"}
        alt="2022"
        src={require(`../../../images/gallery/2022/10/img_${i + 1}.${ext}`)}
      />
    );
  });
  const folder11 = [...Array(16)].map((e, i) => {
    let ext = "jpg";
    return (
      <img
        style={{ border: "1px solid black" }}
        className={"champions-images"}
        alt="2022"
        src={require(`../../../images/gallery/2022/11/img_${i + 1}.${ext}`)}
      />
    );
  });

  const folder12 = [...Array(4)].map((e, i) => {
    let ext = "jpg";
    return (
      <img
        style={{ border: "1px solid black" }}
        className={"champions-images"}
        alt="2022"
        src={require(`../../../images/gallery/2022/12/img_${i + 1}.${ext}`)}
      />
    );
  });
  const folder13 = [...Array(3)].map((e, i) => {
    let ext = "jpg";
    return (
      <img
        style={{ border: "1px solid black" }}
        className={"champions-images"}
        alt="2022"
        src={require(`../../../images/gallery/2022/13/img_${i + 1}.${ext}`)}
      />
    );
  });
  const folder14 = [...Array(2)].map((e, i) => {
    let ext = "jpg";
    return (
      <img
        style={{ border: "1px solid black" }}
        className={"champions-images"}
        alt="2022"
        src={require(`../../../images/gallery/2022/14/img_${i + 1}.${ext}`)}
      />
    );
  });
  const folder15 = [...Array(3)].map((e, i) => {
    let ext = "jpg";
    return (
      <img
        style={{ border: "1px solid black" }}
        className={"champions-images"}
        alt="2022"
        src={require(`../../../images/gallery/2022/15/img_${i + 1}.${ext}`)}
      />
    );
  });
  const folder16 = [...Array(4)].map((e, i) => {
    let ext = "jpg";
    return (
      <img
        style={{ border: "1px solid black" }}
        className={"champions-images"}
        alt="2022"
        src={require(`../../../images/gallery/2022/16/img_${i + 1}.${ext}`)}
      />
    );
  });
  return (
    <React.Fragment>
      <br />
      <br />
      <div className="flex-custom-container">{folder1}</div>
      <div className="flex-custom-container">{folder2}</div>
      <div className="flex-custom-container">{folder3}</div>
      <div className="flex-custom-container">{folder4}</div>
      <div className="flex-custom-container">{folder5}</div>,
      <div className="flex-custom-container">{folder6}</div>,
      <div className="flex-custom-container">{folder7}</div>
      <div className="flex-custom-container">{folder8}</div>
      <div className="flex-custom-container">{folder9}</div>
      <div className="flex-custom-container">{folder10}</div>
      <div className="flex-custom-container">{folder11}</div>,
      <div className="flex-custom-container">{folder12}</div>,
      <div className="flex-custom-container">{folder13}</div>
      <div className="flex-custom-container">{folder14}</div>
      <div className="flex-custom-container">{folder15}</div>
      <div className="flex-custom-container">{folder16}</div>;
    </React.Fragment>
  );
}

export default Gallery2022;
